import { NewsletterFormField } from 'types/config.types';

const mergeDynamicFormFields = (dynamicFormFields: NewsletterFormField[]) => {
  const mergedDynamicFormFields = dynamicFormFields.reduce(
    (accumulator, currentField) => {
      const existingField = accumulator.find((field) => field.name === currentField.name);

      if (existingField) {
        existingField.newsletterLabels = existingField.newsletterLabels.concat(
          currentField.newsletterLabels.filter(
            (label) => !existingField.newsletterLabels.includes(label),
          ),
        );
      } else {
        accumulator.push(currentField);
      }

      return accumulator;
    },
    [],
  );

  return mergedDynamicFormFields;
};

export default mergeDynamicFormFields;
